export default {
  accountPlans: [],
  accountPlan: {}
}
